import React, { useEffect, useState, useRef } from "react";
import { Player, PlayerStats, PositionRank } from "../../types/types";
import _, { sortBy } from "underscore";
import {
  Paper,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import PlayerCard from "../Cards/PlayerCard";
import styled from "@emotion/styled";
import { CalculatePlayerStats } from "../../globals/Functions";
import { FILTERITEMS } from "../../globals/Globals";
import PlayerCardExtraStat from "../Cards/PlayerCardExtraStat";
import { CURRENT_SEASON } from "../../globals/BBLData";

export interface Props {
  players: Player[];
  hideposition?: boolean;
  positionname: string;
}

export interface SortObject {
  term: string;
  label: string;
}

export interface PlayerStat {
  player: Player;
  stats: PlayerStats;
  show: boolean;
}

export interface PlayerStatsList {
  players: PlayerStat[];
}

const NEGATIVESORT = ["scbe", "posrank", "avgpts"];

function PlayerCardsContainer({ players, hideposition, positionname }: Props) {
  const [theplayers, setPlayers] = useState<Player[]>(players);
  const [sortedBy, setSortedBy] = useState<string>("posrank");
  const [sortDirection, setSortDirection] = useState<string>("ascending");
  const [playerStatList, setPlayerStatList] = useState<PlayerStat[]>([]);
  const [selectedPosition, setSelectedPosition] = useState<string>("*");

  useEffect(() => {
    let npl = CalculateStats();
    TriggerSort(npl, sortedBy, sortDirection);
  }, [players]);

  useEffect(() => {
    //TriggerSort();
  }, [sortedBy]);

  let repeatlength: number = 0;

  playerStatList.map(function (psl) {
    if (psl.show) {
      repeatlength = repeatlength + 1;
    }
  });
  if (repeatlength % 2 === 0) {
    repeatlength = repeatlength / 2;
  } else {
    repeatlength = (repeatlength + 1) / 2;
  }
  const GridContainer = styled.div`
    display: grid;
    overflow-x: scroll;
    grid-template-rows: auto auto;
    grid-auto-flow: column;
    grid-template-columns: repeat(${repeatlength}, 150px);
    grid-row-gap: 1rem;
    padding-bottom: 1rem;

    @media (min-width: 1024px) {
      padding-left: 0.5rem;
      grid-template-columns: repeat(${repeatlength}, 170px);
    }
  `;
  function handlePositionChange(
    event: SelectChangeEvent<string>,
    child: React.ReactNode
  ) {
    setSelectedPosition(event.target.value);
    TriggerFilter(playerStatList, event.target.value);
  }

  function TriggerFilter(playerstatlist: PlayerStat[], filterterm: string) {
    let newplayers = playerstatlist.slice();

    newplayers = newplayers.map(function (playerstat) {
      if (filterterm === "*") {
        playerstat.show = true;
      } else {
        playerstat.player.positions.map(function (position) {
          if (position.name === filterterm) {
            playerstat.show = true;
          } else {
            playerstat.show = false;
          }
        });
      }
      return playerstat;
    });
    setPlayerStatList(newplayers);
  }

  function CalculateStats() {
    let newPlayerStatList: PlayerStat[] = [];
    players.map(function (player) {
      let thestat = player.stats[0];
      player.stats.map(function (stat) {
        if (stat.season === CURRENT_SEASON) {
          thestat = stat;
        }
      });
      var playerstats = CalculatePlayerStats({ games: thestat?.last5Games });
      newPlayerStatList.push({
        player: player,
        stats: playerstats,
        show: true,
      });
    });
    return newPlayerStatList;
  }

  function TriggerSort(
    playerstatlist: PlayerStat[],
    sortterm: string,
    sortDirection: string
  ) {
    let newplayers = playerstatlist.slice();
    newplayers = _.sortBy(newplayers, function (player) {
      console.log("BSR: ", player);
      if (sortterm === "avgpts") {
        if (sortDirection !== "ascending") {
          return -player.player.stats[0][sortterm];
        } else {
          return player.player.stats[0][sortterm];
        }
      } else if (sortterm === "posrank") {
        let found = false;
        let thisrank = 1000;
        //let lastgame = player.player.stats[0]? player.player.stats[0].last5Games[player.player.stats[0].last5Games.length -1] : null;
        let lastgame = player.player.stats[0].lastgame;

        if (lastgame) {
          lastgame.positionrank.map(function (rank: PositionRank) {
            if (rank.position.name === positionname) {
              found = true;
              thisrank = rank.totalrank;
            }
          });
        }

        if (sortDirection !== "ascending") {
          if (found) {
            return -thisrank;
          } else {
            return -10000;
          }
        } else {
          if (found) {
            return thisrank;
          } else {
            return 10000;
          }
        }
      } else if (sortterm === "Bowl Strike Rate") {
        if (sortDirection !== "ascending") {
          return -player.player.bwlStrikeStat.avgSR;
        } else {
          return player.player.bwlStrikeStat.avgSR;
        }
      } else if (sortterm === "Bat Strike Rate") {
        if (sortDirection !== "ascending") {
          return -player.player.batStrikeStat.avgSR;
        } else {
          return player.player.batStrikeStat.avgSR;
        }
      } else {
        let lastgame = player.player.stats[0].lastgame;
        if (lastgame) {
          if (sortDirection !== "ascending") {
            return -lastgame[sortterm];
          } else {
            return lastgame[sortterm];
          }
        }
      }
    });

    setPlayerStatList(newplayers);
  }

  function handleSortChange(
    event: SelectChangeEvent<string>,
    child: React.ReactNode
  ) {
    setSortedBy(event.target.value);
    TriggerSort(playerStatList, event.target.value, sortDirection);
  }

  function handleSortDirectionChange(
    event: SelectChangeEvent<string>,
    child: React.ReactNode
  ) {
    setSortDirection(event.target.value);
    TriggerSort(playerStatList, sortedBy, event.target.value);
  }
  return (
    <Paper style={{ padding: "0.5rem" }} elevation={5}>
      <div style={{ display: "flex" }}>
        {!hideposition ? (
          <FormControl
            component="fieldset"
            sx={{ marginBottom: "1rem", padding: "0.5rem", width: "110px" }}
          >
            <FormLabel component="legend" sx={{ textAlign: "left" }}>
              Position
            </FormLabel>
            <Select
              value={selectedPosition}
              label="Position"
              onChange={handlePositionChange}
            >
              <MenuItem value="*">All</MenuItem>
              <MenuItem value="BAT">Bat</MenuItem>
              <MenuItem value="BWL">Bowl</MenuItem>
              <MenuItem value="WKP">Wicket Keeper</MenuItem>
            </Select>
          </FormControl>
        ) : null}
        <FormControl
          component="fieldset"
          sx={{ marginBottom: "1rem", padding: "0.5rem" }}
        >
          <FormLabel component="legend" sx={{ textAlign: "left" }}>
            Sort
          </FormLabel>
          <Select value={sortedBy} onChange={handleSortChange}>
            {FILTERITEMS.map(function (filteritem) {
              return <MenuItem value={filteritem}>{filteritem}</MenuItem>;
            })}
            <MenuItem value="posrank">Rank</MenuItem>
          </Select>
        </FormControl>

        <FormControl
          component="fieldset"
          sx={{ marginBottom: "1rem", padding: "0.5rem" }}
        >
          <FormLabel component="legend" sx={{ textAlign: "left" }}>
            Direction
          </FormLabel>
          <Select value={sortDirection} onChange={handleSortDirectionChange}>
            <MenuItem value="ascending">Ascending</MenuItem>
            <MenuItem value="descending">Descending</MenuItem>
          </Select>
        </FormControl>
      </div>
      <GridContainer>
        {playerStatList.map(function (playerstat, index) {
          if (playerstat.show) {
            let thevalue;
            let lastgame = playerstat.player.stats[0].lastgame;
            let thestat = playerstat.player.stats[0];
            playerstat.player.stats.map(function (stat) {
              if (stat.season === CURRENT_SEASON) {
                thestat = stat;
                if (stat.lastgame) {
                  lastgame = stat.lastgame;
                }
              }
            });
            let lastyearAvg = 0;
            let prevYearAvg = 0;
            lastyearAvg = thestat.lastSeasonAVGPoints
              ? thestat.lastSeasonAVGPoints.toFixed(2)
              : 0;
            prevYearAvg = thestat.previousSeasonAVG
              ? thestat.previousSeasonAVG.toFixed(2)
              : 0;
            if (sortedBy === "posrank") {
              if (lastgame) {
                lastgame.positionrank.map(function (rank: PositionRank) {
                  if (
                    rank.position.name === positionname ||
                    positionname === "any"
                  ) {
                    thevalue = rank.totalrank;
                  }
                });
                console.log("NO LAST GAME:1 ", playerstat, thevalue);
              } else {
                playerstat.player.positionrank.map(function (posrank) {
                  if (
                    posrank.position.name === positionname ||
                    positionname === "any"
                  ) {
                    thevalue = posrank.totalrank;
                  }
                });
                console.log("NO LAST GAME: ", playerstat);
              }
            } else if (sortedBy === "Bat Strike Rate") {
              thevalue = playerstat.player.batStrikeStat.avgSR;
            } else if (sortedBy === "Bowl Strike Rate") {
              thevalue = playerstat.player.bwlStrikeStat.avgSR;
            } else {
              thevalue = playerstat.player.stats[0].lastgame
                ? playerstat.player.stats[0].lastgame[sortedBy]
                : "";
            }
            const EXTRASTATLABELS = {
              "Bat Strike Rate": {
                label: "BAT SR",
                toolTip: "Batting Strike Rate",
              },
              "Bowl Strike Rate": {
                label: "BWL SR",
                toolTip: "Bowling Strike Rate",
              },
              posrank: { label: "Rank", toolTip: "Rank" },
              lastyearAvg: {
                label: "BBL11 Avg",
                toolTip: "Avg pts scored in BBL11",
              },
            };
            const extraStats = [
              {
                label: "BBL11",
                toolTipText: "Avg pts scored in BBL11",
                value: lastyearAvg,
              },
              {
                label: "BBL10",
                toolTipText: "Avg pts scored in BBL10",
                value: prevYearAvg,
              },
            ];
            let label = "";
            let tooltip = "";
            if (sortedBy in EXTRASTATLABELS) {
              label = EXTRASTATLABELS[sortedBy]["label"];
              tooltip = EXTRASTATLABELS[sortedBy]["tooltip"];
            } else {
              label = sortedBy;
            }
            let extrastat = {
              label: label,
              value: thevalue,
              tooltip: tooltip,
            };
            if (lastgame) {
              return (
                <div style={{ marginRight: "1rem" }}>
                  <PlayerCardExtraStat
                    player={playerstat.player}
                    onPlusClick={(player) => console.log("add player")}
                    onNavClick={(player) => console.log("nav to player")}
                    width={"100%"}
                    extraStat={extrastat}
                    extraStats={extraStats}
                  />
                  {/* <PlayerCard player={playerstat.player} onPlusClick={player => console.log("add player")} onNavClick={player => console.log("nav to player")} width={'100%'}/> */}
                </div>
              );
            }
          }
        })}
      </GridContainer>
    </Paper>
  );
}

export default PlayerCardsContainer;
